import { Colors } from '@lean-body/src/view/styles/index';
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
dayjs.extend(isSameOrAfter);
// カレンダーの日にちの色スタイル
const highlightTypeToDayStyleWithState = new Map([
    [
        'accent',
        {
            normal: { backgroundColor: Colors.BackgroundAccent, color: Colors.Accent },
            selected: { backgroundColor: Colors.Accent, color: Colors.White },
        },
    ],
    [
        'default',
        {
            normal: { backgroundColor: Colors.BackgroundBlue, color: Colors.PrimaryDark },
            selected: { backgroundColor: Colors.PrimaryDark, color: Colors.White },
        },
    ],
]);
export class LiveCalendarDayState {
    constructor(data) {
        Object.defineProperty(this, "year", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "month", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "day", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "state", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "highlightType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "style", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.year = data.year;
        this.month = data.month;
        this.day = data.day;
        this.state = data.state;
        this.highlightType = data.highlightType;
        this.style =
            highlightTypeToDayStyleWithState.get(this.highlightType) || highlightTypeToDayStyleWithState.get('default');
    }
    get date() {
        return new Date(this.year, this.month - 1, this.day);
    }
    get dayjs() {
        return dayjs(this.date);
    }
    get isAfterToday() {
        return this.dayjs.isSameOrAfter(dayjs().startOf('day'));
    }
}
